export enum Environment {
    DEVELOP = "develop",
    STAGE = "stage",
    PRODUCTION = "production",
}